import React from 'react'
import styled from 'styled-components'
import Box from 'core-system/Box/Box'
import Text from 'core-system/Text/Text'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import Divider from 'core-system/Divider/Divider'
import LockedBadge from 'core-system/Locked/LockedBadge'
import LockedBlur from 'core-system/Locked/LockedBlur'

const Container = styled(Box)`
  padding: 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const TitleContainer = styled.div`
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-direction: row;
  margin-bottom: 0.5rem;
`

const BodyContainer = styled.div`
  position: relative;
  padding: 1.25rem 0 1.75rem 0;
`

interface TitleButtonContainerProps {
  title: string
  children: React.ReactNode
  icon?: React.ReactNode
  buttonText?: string
  onClick?: () => void
  bodyContainerStyle?: React.CSSProperties
  headerContainerStyle?: React.CSSProperties
  isLoading?: boolean
  isLocked?: boolean
}

const TitleButtonContainer = ({
  title,
  icon,
  children,
  buttonText,
  onClick,
  bodyContainerStyle,
  headerContainerStyle,
  isLoading,
  isLocked,
  ...props
}: TitleButtonContainerProps) => {
  return (
    <Container isLoading={isLoading} {...props}>
      <div>
        <div style={headerContainerStyle}>
          <TitleContainer>
            {icon && icon}
            <Text variant='action2' fontWeight={500} marginBottom={0.5}>
              {title}
            </Text>
          </TitleContainer>
          <Divider />
        </div>
        <BodyContainer style={bodyContainerStyle}>
          {isLocked ? <LockedBlur>{children}</LockedBlur> : children}
        </BodyContainer>
      </div>
      {isLocked && <LockedBadge />}
      {buttonText && (
        <SecondaryButton
          fullWidth
          onClick={onClick}
          style={{ padding: '0.3rem' }}
        >
          {buttonText}
        </SecondaryButton>
      )}
    </Container>
  )
}

export default TitleButtonContainer
